import apiProfile from '@/api/member/profile';

const defaultState = () => ({
	profileData: [],
	loadProfile: false,
	detailProfile: {},
	profilePagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setloadProfile(state, data) {
		state.loadProfile = data
	},
	setProfileDetail(state, data) {
		state.detailProfile = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearProfile(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getProfileDetail({ commit }) {
		commit('setloadProfile', true);
		return new Promise((resolve) => {
			apiProfile.getProfileDetail().then(({ data: { data } }) => {
				commit('setProfileDetail', data.results);
				resolve(true);
			}).catch(() => {
				commit('setProfileDetail', {});
			}).then(() => {
				commit('setloadProfile', false);
			});
		});
	},
	createStore({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiProfile.createStore(params).then(({ data }) => {
				dispatch('success', data)
				commit('auth/success', data.data, { root: true })
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	editProfile({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiProfile.editProfile(params).then(({ data }) => {
				dispatch('success', data)
				commit('auth/setProfileData', data.data, { root: true })
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	editProfileMLM({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiProfile.editProfileMLM(params).then(({ data }) => {
				dispatch('success', data)
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				reject(data)
				dispatch('errorHandler', data);
			})
		});
	},
	uploadImage({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiProfile.uploadImage(params).then(({ data }) => {
				dispatch('success', data)
				commit('auth/setImageData', data.data.image, { root: true })
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	updateStoreBank({ dispatch,commit }, params) {
		return new Promise((resolve, reject) => {
			apiProfile.updateStoreBank(params).then((data) => {
				// console.log("dataaa", data)
				dispatch('success', data.data)
				commit('makeAlert', { code: 'success', type: 'success', message: data.data.message, show: true }, { root: true });
				// resolve(data.data)
				resolve(true);

			}).catch((err) => {
				// console.log("err",err)
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(true)
			})
		});
	},
	editPassword({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiProfile.editPassword(params).then(({ data }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: data.message, show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	editEmail({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiProfile.editEmail(params).then(({ data }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: data.message, show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
			await commit('progress', false, { root: true });
		});
	},
	editUsername({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiProfile.editUsername(params).then(({ data }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: data.message, show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
			await commit('progress', false, { root: true });
		});
	},
	editMobilephone({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiProfile.editMobilephone(params).then(({ data }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: data.message, show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
			await commit('progress', false, { root: true });
		});
	},
	checkKTPMember({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiProfile.checkKTPMember(params).then(({ data }) => {
				dispatch('success', data)
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data)
			})
			await commit('progress', false, { root: true });
		});
	},
	checkMLM({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiProfile.checkMLM(params).then(({ data }) => {
				dispatch('success', data)
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data)
			})
			await commit('progress', false, { root: true });
		});
	},
	loginMLM({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiProfile.loginMLM(params).then(({ data }) => {
				dispatch('success', data)
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data)
			})
			await commit('progress', false, { root: true });
		});
	},
	getTypeMember() {
		return new Promise((resolve, reject) => {
			apiProfile.getTypeMember().then(({ data: { data } }) => {
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data)
			})
		});
	},
	getBankProspect() {
		return new Promise((resolve, reject) => {
			apiProfile.getBankProspect().then(({ data: { data } }) => {
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data)
			})
		});
	},
	getProspect() {
		return new Promise((resolve, reject) => {
			apiProfile.getProspect().then(({ data: { data } }) => {
				resolve(data);
			}).catch(() => {
				// const { data } = err.response;
				reject(true)
			})
		});
	},
	saveProspect({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiProfile.saveProspect(params).then(({ data }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: data.message, show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
			await commit('progress', false, { root: true });
		});
	},
	success({ commit }, response) {
		commit('saveResponse', response)
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
				commit('validationError', response.data);
				break;

			case 'error_multiple_alert':
				commit('multipleAlert', response.data.error)
				break;

			default:
				commit('makeAlert', { code: 'error_response', type: 'error', message: response.message, show: true }, { root: true });
				break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};